import { render, staticRenderFns } from "./ThreadSummary.vue?vue&type=template&id=3c8c09eb&scoped=true"
import script from "./ThreadSummary.vue?vue&type=script&lang=js"
export * from "./ThreadSummary.vue?vue&type=script&lang=js"
import style0 from "./ThreadSummary.vue?vue&type=style&index=0&id=3c8c09eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8c09eb",
  null
  
)

export default component.exports